import React from 'react'

import OfferLabels from 'components/Common/Labels/OfferLabels'
import { useAppSelector } from 'hooks/reduxHooks'
import { useOfferInclusions } from 'hooks/useOfferInclusions'
import { isLEHotel } from 'lib/offer/offerTypes'
import { isLuxuryPlusEnabled } from 'loyalty/selectors/featureToggle'
import { HotelItem, HomeAndVillasItem } from 'tripPlanner/types/tripItem'
import { isLeBookmark } from 'tripPlanner/utils'
import { extractPriceAndValue } from 'tripPlanner/utils/bookmarkCard'
import { getAccommodationPriceAndLabel } from 'tripPlanner/utils/hotel'

interface Props {
  item: HotelItem | HomeAndVillasItem
  offer: App.HotelOffer | App.BundleOffer | App.BedbankOffer | App.VillaOffer
  viewAsTemplate: boolean
}

function HotelUrgencyLabels({ item, offer, viewAsTemplate }: Props) {
  const isLuxPlusEnabled = useAppSelector(isLuxuryPlusEnabled)

  const savedItemData = 'savedItemData' in item ? item.savedItemData : undefined
  let pkg: App.Package | undefined = undefined
  if (offer && isLEHotel(offer)) {
    const packageId = savedItemData?.packageId
    if (packageId) {
      pkg = offer.packages.find((p) => p.id === packageId)
    }
    if (!pkg) {
      pkg = offer.lowestPricePackage
    }
  }

  const { loyaltyInclusions } = useOfferInclusions(pkg, {
    checkIn: item.startDate,
    checkOut: item.endDate,
  })

  if (isLeBookmark(item) && offer && isLEHotel(offer)) {
    if (viewAsTemplate) {
      if (offer.lowestPricePackage) {
        const { price, luxPlusPrice } = extractPriceAndValue({
          pkg: offer.lowestPricePackage,
        })
        const saveAmount =
          price && luxPlusPrice && luxPlusPrice < price
            ? price - luxPlusPrice
            : undefined
        return (
          <OfferLabels
            offer={offer}
            saveAmount={saveAmount}
            showMemberInclusionLabels={loyaltyInclusions.length > 0}
          />
        )
      }
    } else {
      const { price, luxPlusPrice } = getAccommodationPriceAndLabel(
        offer,
        item.savedItemData,
      )

      if (isLuxPlusEnabled) {
        const saveAmount =
          price && luxPlusPrice && luxPlusPrice < price
            ? price - luxPlusPrice
            : undefined
        return (
          <OfferLabels
            offer={offer}
            saveAmount={saveAmount}
            showMemberInclusionLabels={loyaltyInclusions.length > 0}
          />
        )
      }
    }
  }

  if (offer && isLEHotel(offer)) {
    return <OfferLabels offer={offer} />
  }

  return null
}

export default HotelUrgencyLabels
